module.exports = __webpack_public_path__ + "img/huiTalkBanner.239bb136.png";